/** Keeps a copy click from reaching the surrounding row, card or form. */
export function preventClick(event: React.MouseEvent<HTMLButtonElement>) {
  event.preventDefault()
  event.stopPropagation()
}
